import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CoManageDataAccessObject } from '@safarilaw-webapp/feature/co-manage/data-access';

import { AuthService, PermissionsService } from '@safarilaw-webapp/shared/auth/store-access';
import { SafariObject, UserPermissionType } from '@safarilaw-webapp/shared/common-objects-models';
import { dataAccessMixin } from '@safarilaw-webapp/shared/redux';
import { SafariRouterReduxObject } from '@safarilaw-webapp/shared/routing-utility/store-access';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
// eslint-disable-next-line @typescript-eslint/no-deprecated -- will fix later
export class PermissionGuardService extends dataAccessMixin(class {}) {
  constructor(
    protected _store: Store<any>,
    protected _actions: Actions,
    private _userPermissionsService: PermissionsService,
    private _authService: AuthService,
    private _routerReduxObject: SafariRouterReduxObject,
    public CoManageObject: CoManageDataAccessObject
  ) {
    super();
  }
  private blockNavigate(): boolean {
    this._store.dispatch(this._routerReduxObject.default.actions.routerNavigate({ payload: { path: ['/403'] } }));
    return false;
  }
  canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    return this._authService.isAuthenticated$.pipe(
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          return of(false);
        }
        return this.observeObject$(this.CoManageObject.MyUser, SafariObject.NOID).pipe(
          map(o => {
            if (o == null) {
              return this.blockNavigate();
            }
            const permissionsRequested = routeSnapshot.data['permissions'];
            for (const permissionRequested of permissionsRequested) {
              if (permissionRequested === UserPermissionType.Self) {
                // Special handling for "Self" permission. This is a special type
                // of permission that checks for user ID and a well-known URL. If all matches
                // then the user is editing self
                if (routeSnapshot.url && routeSnapshot.url.length == 3) {
                  if (routeSnapshot.url[0]?.path == 'cousers' && routeSnapshot.url[1]?.path == 'edit' && (routeSnapshot.url[2]?.path == 'me' || routeSnapshot.url[2]?.path == o.id)) {
                    return true;
                  }
                }
              }

              if (this._userPermissionsService.isInRole(o, permissionRequested)) {
                return true;
              }
            }
            return this.blockNavigate();
          })
        );
      })
    );
  }
}
